<section class="panel">
  <article class="panel__wrapper">
    <header
      class="panel__wrapper__header"
      appAccountColorBackground
      #backgroundDirective="appAccountColorBackground"
      [colorName]="panelDef.color"
    >
      @if (!ui.editMode) {
        <p
          class="panel__wrapper__header__title"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >
          {{ panelDef.title }}
        </p>
      } @else {
        <div class="panel__wrapper__header__title-edit">
          <mat-form-field>
            <input matInput [formControl]="title" placeholder="Panel title" autocomplete="off" />
          </mat-form-field>
        </div>
      }
      <div class="panel__wrapper__header__actions">
        @if (!ui.editMode) {
          <button mat-icon-button type="button" [matMenuTriggerFor]="moreMenu">
            <mat-icon class="icon-size-20" svgIcon="more_vert"></mat-icon>
          </button>
          <mat-menu #moreMenu>
            <button mat-menu-item (click)="toggleEditMode()" type="button">
              <mat-icon svgIcon="edit"></mat-icon>
              Edit Layout
            </button>
          </mat-menu>
        }
        @if (ui.editMode) {
          <div class="panel__wrapper__header__actions__layout">
            <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelEdit()">
              <mat-icon svgIcon="cancel"></mat-icon>
            </button>
            <button mat-icon-button type="button" matTooltip="Save" (click)="saveLayout()">
              <mat-icon svgIcon="save"></mat-icon>
            </button>
          </div>
        }
      </div>
    </header>
    <div class="panel__wrapper__body">
      <app-related-table-core
        [panelDef]="panelDef"
        [account]="account"
        [model]="model"
        [customObjectsOnly]="customObjectsOnly"
        [relatedToType]="relatedToType"
        [readonly]="readonly"
      ></app-related-table-core>
    </div>
  </article>
</section>
